import { searchClient } from "./client";

export const getAirports = () => searchClient.get("/apiv3/flight/airports");

export const getAirlines = () => searchClient.get("/apiv3/flight/airlines");
